<template>
<div>
  <v-container fluid grid-list-md>
  <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
  <v-data-table
    dense
    :headers="headers"
    :items="account1s"
    :search="search"
    sort-by="id"
    class="elevation-1"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="20"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{lang.Account1s}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <template v-slot:activator="{ on }">
            <v-btn fab dark class="indigo" v-on="on">
               <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-text-field
                        v-model="editedItem.account1"
                        :label="lang.Account1"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="8" lg="8" xl="8">
                      <v-text-field
                        v-model="editedItem.account1Description"
                        :label="lang.Account1Description"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">

                    </v-col>
                    <v-col cols="12" sm="8" md="8" lg="8" xl="8">
                      <v-text-field
                        v-model="editedItem.account1Description2"
                        :label="lang.Account1Description2"
                      ></v-text-field>
                    </v-col>
                  </v-row>


                  <v-row v-if="errorMatch">                    
                      <div class="red" v-html="errorMatch" />
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{langC.Cancel}}</v-btn>
                    <v-btn :disabled="!valid" color="success" text @click="save">{{langC.Save}}</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.defaultCompany`]="{ item }">
      <span v-if="item.defaultCompany"><v-icon>mdi-check</v-icon></span>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-trash-can
      </v-icon>
    </template>
    <template v-slot:no-data>
      {{ lang.CompUsersEmpty }}
    </template>
  </v-data-table>
  </v-container>
  </div>
</template>

<script>
import Account1Service from '@/services/Account1Service'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'

  export default {
    name: 'account1CRUD',
    data: () => ({
      search: '',
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal2: false,
      menu2: false,
      lang: {},
      langC: {},
      saving: false,
      error: null,
      errorMatch: null,
      modal: false,
      show1: false,
      show2: false,
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: "",
        databaseDocID: 0
      },
      dialog: false,
      headers: [ 
      ],
      account1s: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 0,
        email: '',
        account1: '',
        account1Description: '',
        account1Description2: '',
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
        LastUpdateBy: ''
      },
      confpassword: '',
      privitems: [ ],
      valid: true,
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be 6 or more characters',
      ],
      locusers: [],
      select: { },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? this.lang.NewAccount1: this.lang.EditAccount1
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      'select' () {
        this.choosedUser(this.select.id)
      }
    },

    async mounted() {
      if (this.$store.state.language === "EN") {
        this.lang = ledgerEN
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = ledgerHR
        this.langC = commHr;
      }
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
        this.defaultItem.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.companyName) {
        this.defaultItem.CompanyNameDatabase = this.$store.state.companyName
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }

      this.privitems.push(
        { text: this.lang.Priv1, value: 1 },
        { text: this.lang.Priv2, value: 2 },
        { text: this.lang.Priv3, value: 3 },
        { text: this.lang.Priv4, value: 4 },
        { text: this.lang.Priv5, value: 5 }
      )
      this.headers.push(
        {
          text: this.lang.Account1,
          align: 'left',
          sortable: true,
          value: 'account1',
          width: '80px'
        },
        { text: this.lang.Account1Description, value: 'account1Description', align: 'left', width: '750px' },
        {text: this.lang.Actions, value: 'action', sortable: false },
      )
      this.defaultItem.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.defaultItem.email = this.$store.state.user.email ? this.$store.state.user.email : ''
      this.defaultItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : ''
      this.defaultItem.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.defaultItem.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : ''

    },

    created () {
      this.initialize()
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      async initialize () {
        try {
          this.saving = true
          this.account1s = (await Account1Service.show()).data.account1s   
          this.saving = false
          this.errorMatch = false
          this.editedItem = this.defaultItem
          this.select = {}
        } catch (err) {
          this.error = err
          alert(this.langC.ErrorCannotLoad)
        }
      },
      editItem (item) {
        this.errorMatch = false
        this.editedIndex = this.account1s.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        try {
          const index = this.account1s.indexOf(item)
          const warningMessage = item.account1 + ' ' + item.account1Description
          if (confirm(this.langC.AreYouShureToDelete + ' ' + warningMessage + '!') && this.account1s.splice(index, 1)) {
            await Account1Service.delete(item.id)
            this.initialize()
          }
        } catch(err) {
          this.error = err
          alert(this.langC.ErrorCannotDelete)
        }
        
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        try {
           let doneOK = false
           if (this.editedIndex > -1) {
              this.editedItem.account1Description = this.editedItem.account1Description ? (this.editedItem.account1Description).trim() : ''
              this.editedItem.account1Description2 = this.editedItem.account1Description2 ? (this.editedItem.account1Description2).trim() : ''
              await Account1Service.put(this.editedItem)
              doneOK = true
            } else {
              delete this.editedItem.id
              this.editedItem.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
              this.editedItem.email = this.$store.state.user.email ? this.$store.state.user.email : ''
              this.editedItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : ''
              this.editedItem.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
              this.editedItem.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : ''
              this.editedItem.account1Description = this.editedItem.account1Description ? (this.editedItem.account1Description).trim() : ''
              this.editedItem.account1Description2 = this.editedItem.account1Description2 ? (this.editedItem.account1Description2).trim() : ''
              await Account1Service.post(this.editedItem)
              doneOK = true
            }
            if (doneOK) {
              this.initialize()
              this.close()
            }
        } catch(err) {
          this.error = err
          alert(this.langC.ErrorCannotSave)
        }
      },
      localDate(dateToFormat) {
       return dateFormat(dateToFormat)
      },
      choosedUser (choosedId) {
        if (this.locusers) {
          this.locusers.forEach(element => {
            if (element.id === choosedId) {
              this.editedItem.UserId = element.id
              this.editedItem.email = element.email
            }
          })
        }
      }
    },
  }
</script>